import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { ContractSupplierFilters } from '@types'

import { ContractsSupplierApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los contratos',
  })
}

const useContractsSupplier = (filters?: ContractSupplierFilters) => {
  const { data: contractsSupplier, isLoading: contractsSupplierIsLoading } = useQuery(
    [QUERY_KEYS.CONTRACTS_SUPPLIER, filters],
    () => ContractsSupplierApi.getContractsSupplier({ filters }),
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    contractsSupplier,
    contractsSupplierIsLoading,
  }
}

export default useContractsSupplier
